import { TOURNAMENT_DETAILS_ACTION } from 'core/constants/Actions'
import { TypedThunk, TypedDispatch } from 'App/Store'
import { getTournamentById } from 'core/services/Tournament'

export function tournamentDetails(tournamentId: string): TypedThunk {
  return async (dispatch: TypedDispatch) => {
    dispatch({ type: TOURNAMENT_DETAILS_ACTION.REQUEST })
    const apiResponse = await getTournamentById(tournamentId)
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: TOURNAMENT_DETAILS_ACTION.SUCCESS,
        payload: { tournament: apiResponse.data.tournament }
      })
    } else {
      dispatch({
        type: TOURNAMENT_DETAILS_ACTION.FAILURE
      })
    }
  }
}

export function resetTournamentDetails() {
  return {
    type: TOURNAMENT_DETAILS_ACTION.RESET
  }
}